import { TokenPairFeesResponse } from '@/pages/api/tokens/fees';
import { useQuery } from '@tanstack/react-query';

import { ClientNetworkError } from '@/lib/errors/client';

import { EthereumAddress } from '@/utils/models';
import { routes } from '@/utils/routes';
import { objectToQueryString } from '@/utils/string';

const fetcher = async (url: string) => {
  const res = await fetch(url);

  if (!res.ok) {
    const message = await res.text();
    throw new ClientNetworkError(message);
  }
  return res.json();
};

interface TokenFeeConfigParams {
  tokenAddressA: EthereumAddress | undefined;
  tokenAddressB: EthereumAddress | undefined;
  chainIdA: number | undefined;
  chainIdB: number | undefined;
}

export const tokenFeeConfigQueryKey = (params: TokenFeeConfigParams) =>
  ['token-fee-config', params] as const;

export function useTokenFeeConfig(
  params: TokenFeeConfigParams,
  options: { enabled?: boolean } = {},
) {
  const requiredParams = Object.values(params).every(Boolean);
  const queryString = objectToQueryString(params);
  const url = `${routes.api.TOKEN_FEE_CONFIG}${queryString}`;

  return useQuery<TokenPairFeesResponse | undefined, Error>({
    queryKey: tokenFeeConfigQueryKey(params),
    queryFn: () => fetcher(url),
    enabled: (options.enabled ?? true) && requiredParams,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}
